// source: v2/number_management_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var v2_types_utility_pb = require('../v2/types/utility_pb.js');
goog.object.extend(proto, v2_types_utility_pb);
var v2_types_pagination_pb = require('../v2/types/pagination_pb.js');
goog.object.extend(proto, v2_types_pagination_pb);
var v2_types_number_pb = require('../v2/types/number_pb.js');
goog.object.extend(proto, v2_types_number_pb);
goog.exportSymbol('proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.CreateNumberRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.CreateNumberResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetDDIFiltersRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetDDIFiltersResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetInProgressNumberChangesRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetNumberRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetNumberResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetNumbersRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetNumbersResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.ListCustomerDDIsRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.ListCustomerDDIsResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.UpdateNumberRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.UpdateNumberResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetInProgressNumberChangesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetInProgressNumberChangesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetInProgressNumberChangesRequest.displayName = 'proto.loopup.ctgateway.v2.GetInProgressNumberChangesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse.displayName = 'proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v2.ListCustomerDDIsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.displayName = 'proto.loopup.ctgateway.v2.ListCustomerDDIsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v2.ListCustomerDDIsResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v2.ListCustomerDDIsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.ListCustomerDDIsResponse.displayName = 'proto.loopup.ctgateway.v2.ListCustomerDDIsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetDDIFiltersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetDDIFiltersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetDDIFiltersRequest.displayName = 'proto.loopup.ctgateway.v2.GetDDIFiltersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetDDIFiltersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v2.GetDDIFiltersResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetDDIFiltersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetDDIFiltersResponse.displayName = 'proto.loopup.ctgateway.v2.GetDDIFiltersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest.displayName = 'proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse.displayName = 'proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest.displayName = 'proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserResponse.displayName = 'proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetNumberRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetNumberRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetNumberRequest.displayName = 'proto.loopup.ctgateway.v2.GetNumberRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetNumberResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetNumberResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetNumberResponse.displayName = 'proto.loopup.ctgateway.v2.GetNumberResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetNumbersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v2.GetNumbersRequest.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetNumbersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetNumbersRequest.displayName = 'proto.loopup.ctgateway.v2.GetNumbersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetNumbersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v2.GetNumbersResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetNumbersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetNumbersResponse.displayName = 'proto.loopup.ctgateway.v2.GetNumbersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.CreateNumberRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.CreateNumberRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.CreateNumberRequest.displayName = 'proto.loopup.ctgateway.v2.CreateNumberRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.CreateNumberResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.CreateNumberResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.CreateNumberResponse.displayName = 'proto.loopup.ctgateway.v2.CreateNumberResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.UpdateNumberRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.UpdateNumberRequest.displayName = 'proto.loopup.ctgateway.v2.UpdateNumberRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.UpdateNumberResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.UpdateNumberResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.UpdateNumberResponse.displayName = 'proto.loopup.ctgateway.v2.UpdateNumberResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetInProgressNumberChangesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetInProgressNumberChangesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetInProgressNumberChangesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetInProgressNumberChangesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    loginId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetInProgressNumberChangesRequest}
 */
proto.loopup.ctgateway.v2.GetInProgressNumberChangesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetInProgressNumberChangesRequest;
  return proto.loopup.ctgateway.v2.GetInProgressNumberChangesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetInProgressNumberChangesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetInProgressNumberChangesRequest}
 */
proto.loopup.ctgateway.v2.GetInProgressNumberChangesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoginId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetInProgressNumberChangesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetInProgressNumberChangesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetInProgressNumberChangesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetInProgressNumberChangesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLoginId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string login_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.GetInProgressNumberChangesRequest.prototype.getLoginId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.GetInProgressNumberChangesRequest} returns this
 */
proto.loopup.ctgateway.v2.GetInProgressNumberChangesRequest.prototype.setLoginId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    loginId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    itemCount: (f = msg.getItemCount()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    inProgressList: jspb.Message.toObjectList(msg.getInProgressList(),
    v2_types_number_pb.NumberPendingChanges.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse}
 */
proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse;
  return proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse}
 */
proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoginId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setItemCount(value);
      break;
    case 3:
      var value = new v2_types_number_pb.NumberPendingChanges;
      reader.readMessage(value,v2_types_number_pb.NumberPendingChanges.deserializeBinaryFromReader);
      msg.addInProgress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLoginId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getItemCount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getInProgressList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      v2_types_number_pb.NumberPendingChanges.serializeBinaryToWriter
    );
  }
};


/**
 * optional string login_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse.prototype.getLoginId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse} returns this
 */
proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse.prototype.setLoginId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Int32Value item_count = 2;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse.prototype.getItemCount = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 2));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse} returns this
*/
proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse.prototype.setItemCount = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse} returns this
 */
proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse.prototype.clearItemCount = function() {
  return this.setItemCount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse.prototype.hasItemCount = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated NumberPendingChanges in_progress = 3;
 * @return {!Array<!proto.loopup.ctgateway.v2.NumberPendingChanges>}
 */
proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse.prototype.getInProgressList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v2.NumberPendingChanges>} */ (
    jspb.Message.getRepeatedWrapperField(this, v2_types_number_pb.NumberPendingChanges, 3));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v2.NumberPendingChanges>} value
 * @return {!proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse} returns this
*/
proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse.prototype.setInProgressList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.loopup.ctgateway.v2.NumberPendingChanges=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges}
 */
proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse.prototype.addInProgress = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.loopup.ctgateway.v2.NumberPendingChanges, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse} returns this
 */
proto.loopup.ctgateway.v2.GetInProgressNumberChangesResponse.prototype.clearInProgressList = function() {
  return this.setInProgressList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.repeatedFields_ = [3,4,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.ListCustomerDDIsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    pageNumber: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pageSize: jspb.Message.getFieldWithDefault(msg, 2, 0),
    siteIdList: jspb.Message.toObjectList(msg.getSiteIdList(),
    google_protobuf_wrappers_pb.StringValue.toObject, includeInstance),
    countryCodeList: jspb.Message.toObjectList(msg.getCountryCodeList(),
    google_protobuf_wrappers_pb.StringValue.toObject, includeInstance),
    allocationStatus: jspb.Message.getFieldWithDefault(msg, 5, 0),
    customerId: (f = msg.getCustomerId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    cityList: jspb.Message.toObjectList(msg.getCityList(),
    google_protobuf_wrappers_pb.StringValue.toObject, includeInstance),
    sortBy: jspb.Message.getFieldWithDefault(msg, 8, 0),
    sortDirection: jspb.Message.getFieldWithDefault(msg, 9, 0),
    ddi: (f = msg.getDdi()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    assignedUserName: (f = msg.getAssignedUserName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    hostType: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsRequest}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.ListCustomerDDIsRequest;
  return proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.ListCustomerDDIsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsRequest}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.addSiteId(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.addCountryCode(value);
      break;
    case 5:
      var value = /** @type {!proto.loopup.ctgateway.v2.AllocationStatus} */ (reader.readEnum());
      msg.setAllocationStatus(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomerId(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.addCity(value);
      break;
    case 8:
      var value = /** @type {!proto.loopup.ctgateway.v2.DDISortProperty} */ (reader.readEnum());
      msg.setSortBy(value);
      break;
    case 9:
      var value = /** @type {!proto.loopup.ctgateway.v2.SortDirection} */ (reader.readEnum());
      msg.setSortDirection(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDdi(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAssignedUserName(value);
      break;
    case 12:
      var value = /** @type {!proto.loopup.ctgateway.v2.HostType} */ (reader.readEnum());
      msg.setHostType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.ListCustomerDDIsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSiteIdList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCountryCodeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAllocationStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getCustomerId();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCityList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSortBy();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getSortDirection();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getDdi();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAssignedUserName();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getHostType();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
};


/**
 * optional int32 page_number = 1;
 * @return {number}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsRequest} returns this
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 page_size = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsRequest} returns this
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated google.protobuf.StringValue site_id = 3;
 * @return {!Array<!proto.google.protobuf.StringValue>}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.getSiteIdList = function() {
  return /** @type{!Array<!proto.google.protobuf.StringValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {!Array<!proto.google.protobuf.StringValue>} value
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsRequest} returns this
*/
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.setSiteIdList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.google.protobuf.StringValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.addSiteId = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.google.protobuf.StringValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsRequest} returns this
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.clearSiteIdList = function() {
  return this.setSiteIdList([]);
};


/**
 * repeated google.protobuf.StringValue country_code = 4;
 * @return {!Array<!proto.google.protobuf.StringValue>}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.getCountryCodeList = function() {
  return /** @type{!Array<!proto.google.protobuf.StringValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {!Array<!proto.google.protobuf.StringValue>} value
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsRequest} returns this
*/
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.setCountryCodeList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.google.protobuf.StringValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.addCountryCode = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.google.protobuf.StringValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsRequest} returns this
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.clearCountryCodeList = function() {
  return this.setCountryCodeList([]);
};


/**
 * optional AllocationStatus allocation_status = 5;
 * @return {!proto.loopup.ctgateway.v2.AllocationStatus}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.getAllocationStatus = function() {
  return /** @type {!proto.loopup.ctgateway.v2.AllocationStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.AllocationStatus} value
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsRequest} returns this
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.setAllocationStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional google.protobuf.StringValue customer_id = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.getCustomerId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsRequest} returns this
*/
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.setCustomerId = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsRequest} returns this
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.clearCustomerId = function() {
  return this.setCustomerId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.hasCustomerId = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated google.protobuf.StringValue city = 7;
 * @return {!Array<!proto.google.protobuf.StringValue>}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.getCityList = function() {
  return /** @type{!Array<!proto.google.protobuf.StringValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {!Array<!proto.google.protobuf.StringValue>} value
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsRequest} returns this
*/
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.setCityList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.google.protobuf.StringValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.addCity = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.google.protobuf.StringValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsRequest} returns this
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.clearCityList = function() {
  return this.setCityList([]);
};


/**
 * optional DDISortProperty sort_by = 8;
 * @return {!proto.loopup.ctgateway.v2.DDISortProperty}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.getSortBy = function() {
  return /** @type {!proto.loopup.ctgateway.v2.DDISortProperty} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.DDISortProperty} value
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsRequest} returns this
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.setSortBy = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional SortDirection sort_direction = 9;
 * @return {!proto.loopup.ctgateway.v2.SortDirection}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.getSortDirection = function() {
  return /** @type {!proto.loopup.ctgateway.v2.SortDirection} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.SortDirection} value
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsRequest} returns this
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.setSortDirection = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional google.protobuf.StringValue ddi = 10;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.getDdi = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 10));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsRequest} returns this
*/
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.setDdi = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsRequest} returns this
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.clearDdi = function() {
  return this.setDdi(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.hasDdi = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.StringValue assigned_user_name = 11;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.getAssignedUserName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 11));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsRequest} returns this
*/
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.setAssignedUserName = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsRequest} returns this
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.clearAssignedUserName = function() {
  return this.setAssignedUserName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.hasAssignedUserName = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional HostType host_type = 12;
 * @return {!proto.loopup.ctgateway.v2.HostType}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.getHostType = function() {
  return /** @type {!proto.loopup.ctgateway.v2.HostType} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.HostType} value
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsRequest} returns this
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsRequest.prototype.setHostType = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.ListCustomerDDIsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.ListCustomerDDIsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    v2_types_number_pb.DDI.toObject, includeInstance),
    paginationInfo: (f = msg.getPaginationInfo()) && v2_types_pagination_pb.PaginationInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsResponse}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.ListCustomerDDIsResponse;
  return proto.loopup.ctgateway.v2.ListCustomerDDIsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.ListCustomerDDIsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsResponse}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v2_types_number_pb.DDI;
      reader.readMessage(value,v2_types_number_pb.DDI.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = new v2_types_pagination_pb.PaginationInfo;
      reader.readMessage(value,v2_types_pagination_pb.PaginationInfo.deserializeBinaryFromReader);
      msg.setPaginationInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.ListCustomerDDIsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.ListCustomerDDIsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      v2_types_number_pb.DDI.serializeBinaryToWriter
    );
  }
  f = message.getPaginationInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      v2_types_pagination_pb.PaginationInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DDI items = 1;
 * @return {!Array<!proto.loopup.ctgateway.v2.DDI>}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v2.DDI>} */ (
    jspb.Message.getRepeatedWrapperField(this, v2_types_number_pb.DDI, 1));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v2.DDI>} value
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsResponse} returns this
*/
proto.loopup.ctgateway.v2.ListCustomerDDIsResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loopup.ctgateway.v2.DDI=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v2.DDI}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loopup.ctgateway.v2.DDI, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsResponse} returns this
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional PaginationInfo pagination_info = 2;
 * @return {?proto.loopup.ctgateway.v2.PaginationInfo}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsResponse.prototype.getPaginationInfo = function() {
  return /** @type{?proto.loopup.ctgateway.v2.PaginationInfo} */ (
    jspb.Message.getWrapperField(this, v2_types_pagination_pb.PaginationInfo, 2));
};


/**
 * @param {?proto.loopup.ctgateway.v2.PaginationInfo|undefined} value
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsResponse} returns this
*/
proto.loopup.ctgateway.v2.ListCustomerDDIsResponse.prototype.setPaginationInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.ListCustomerDDIsResponse} returns this
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsResponse.prototype.clearPaginationInfo = function() {
  return this.setPaginationInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.ListCustomerDDIsResponse.prototype.hasPaginationInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetDDIFiltersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetDDIFiltersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetDDIFiltersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetDDIFiltersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    customerId: (f = msg.getCustomerId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetDDIFiltersRequest}
 */
proto.loopup.ctgateway.v2.GetDDIFiltersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetDDIFiltersRequest;
  return proto.loopup.ctgateway.v2.GetDDIFiltersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetDDIFiltersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetDDIFiltersRequest}
 */
proto.loopup.ctgateway.v2.GetDDIFiltersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetDDIFiltersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetDDIFiltersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetDDIFiltersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetDDIFiltersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomerId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue customer_id = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.GetDDIFiltersRequest.prototype.getCustomerId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetDDIFiltersRequest} returns this
*/
proto.loopup.ctgateway.v2.GetDDIFiltersRequest.prototype.setCustomerId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetDDIFiltersRequest} returns this
 */
proto.loopup.ctgateway.v2.GetDDIFiltersRequest.prototype.clearCustomerId = function() {
  return this.setCustomerId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetDDIFiltersRequest.prototype.hasCustomerId = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v2.GetDDIFiltersResponse.repeatedFields_ = [1,2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetDDIFiltersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetDDIFiltersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetDDIFiltersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetDDIFiltersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    countriesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    citiesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    sitesList: jspb.Message.toObjectList(msg.getSitesList(),
    v2_types_utility_pb.NamedIdentifier.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetDDIFiltersResponse}
 */
proto.loopup.ctgateway.v2.GetDDIFiltersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetDDIFiltersResponse;
  return proto.loopup.ctgateway.v2.GetDDIFiltersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetDDIFiltersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetDDIFiltersResponse}
 */
proto.loopup.ctgateway.v2.GetDDIFiltersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addCountries(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addCities(value);
      break;
    case 3:
      var value = new v2_types_utility_pb.NamedIdentifier;
      reader.readMessage(value,v2_types_utility_pb.NamedIdentifier.deserializeBinaryFromReader);
      msg.addSites(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetDDIFiltersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetDDIFiltersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetDDIFiltersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetDDIFiltersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCountriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getCitiesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getSitesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      v2_types_utility_pb.NamedIdentifier.serializeBinaryToWriter
    );
  }
};


/**
 * repeated string countries = 1;
 * @return {!Array<string>}
 */
proto.loopup.ctgateway.v2.GetDDIFiltersResponse.prototype.getCountriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.loopup.ctgateway.v2.GetDDIFiltersResponse} returns this
 */
proto.loopup.ctgateway.v2.GetDDIFiltersResponse.prototype.setCountriesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v2.GetDDIFiltersResponse} returns this
 */
proto.loopup.ctgateway.v2.GetDDIFiltersResponse.prototype.addCountries = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.GetDDIFiltersResponse} returns this
 */
proto.loopup.ctgateway.v2.GetDDIFiltersResponse.prototype.clearCountriesList = function() {
  return this.setCountriesList([]);
};


/**
 * repeated string cities = 2;
 * @return {!Array<string>}
 */
proto.loopup.ctgateway.v2.GetDDIFiltersResponse.prototype.getCitiesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.loopup.ctgateway.v2.GetDDIFiltersResponse} returns this
 */
proto.loopup.ctgateway.v2.GetDDIFiltersResponse.prototype.setCitiesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v2.GetDDIFiltersResponse} returns this
 */
proto.loopup.ctgateway.v2.GetDDIFiltersResponse.prototype.addCities = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.GetDDIFiltersResponse} returns this
 */
proto.loopup.ctgateway.v2.GetDDIFiltersResponse.prototype.clearCitiesList = function() {
  return this.setCitiesList([]);
};


/**
 * repeated NamedIdentifier sites = 3;
 * @return {!Array<!proto.loopup.ctgateway.v2.NamedIdentifier>}
 */
proto.loopup.ctgateway.v2.GetDDIFiltersResponse.prototype.getSitesList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v2.NamedIdentifier>} */ (
    jspb.Message.getRepeatedWrapperField(this, v2_types_utility_pb.NamedIdentifier, 3));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v2.NamedIdentifier>} value
 * @return {!proto.loopup.ctgateway.v2.GetDDIFiltersResponse} returns this
*/
proto.loopup.ctgateway.v2.GetDDIFiltersResponse.prototype.setSitesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.loopup.ctgateway.v2.NamedIdentifier=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v2.NamedIdentifier}
 */
proto.loopup.ctgateway.v2.GetDDIFiltersResponse.prototype.addSites = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.loopup.ctgateway.v2.NamedIdentifier, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.GetDDIFiltersResponse} returns this
 */
proto.loopup.ctgateway.v2.GetDDIFiltersResponse.prototype.clearSitesList = function() {
  return this.setSitesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    serviceUserId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    siteId: (f = msg.getSiteId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    ddi: (f = msg.getDdi()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest}
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest;
  return proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest}
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceUserId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSiteId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDdi(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServiceUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSiteId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDdi();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string service_user_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest.prototype.getServiceUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest} returns this
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest.prototype.setServiceUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue site_id = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest.prototype.getSiteId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest} returns this
*/
proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest} returns this
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest.prototype.clearSiteId = function() {
  return this.setSiteId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest.prototype.hasSiteId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue ddi = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest.prototype.getDdi = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest} returns this
*/
proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest.prototype.setDdi = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest} returns this
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest.prototype.clearDdi = function() {
  return this.setDdi(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserRequest.prototype.hasDdi = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    serviceUserId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ddi: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse}
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse;
  return proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse}
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDdi(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServiceUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDdi();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string service_user_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse.prototype.getServiceUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse} returns this
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse.prototype.setServiceUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ddi = 2;
 * @return {string}
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse.prototype.getDdi = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse} returns this
 */
proto.loopup.ctgateway.v2.AssignDDIToServiceUserResponse.prototype.setDdi = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    serviceUserId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ddi: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest}
 */
proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest;
  return proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest}
 */
proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDdi(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServiceUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDdi();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string service_user_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest.prototype.getServiceUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest} returns this
 */
proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest.prototype.setServiceUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ddi = 2;
 * @return {string}
 */
proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest.prototype.getDdi = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest} returns this
 */
proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserRequest.prototype.setDdi = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    serviceUserId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserResponse}
 */
proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserResponse;
  return proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserResponse}
 */
proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServiceUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string service_user_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserResponse.prototype.getServiceUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserResponse} returns this
 */
proto.loopup.ctgateway.v2.RevokeDDIFromServiceUserResponse.prototype.setServiceUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetNumberRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetNumberRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetNumberRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetNumberRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    ddi: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetNumberRequest}
 */
proto.loopup.ctgateway.v2.GetNumberRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetNumberRequest;
  return proto.loopup.ctgateway.v2.GetNumberRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetNumberRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetNumberRequest}
 */
proto.loopup.ctgateway.v2.GetNumberRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDdi(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetNumberRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetNumberRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetNumberRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetNumberRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDdi();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string ddi = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.GetNumberRequest.prototype.getDdi = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.GetNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.GetNumberRequest.prototype.setDdi = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetNumberResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetNumberResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetNumberResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetNumberResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    number: (f = msg.getNumber()) && v2_types_number_pb.CTNumber.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetNumberResponse}
 */
proto.loopup.ctgateway.v2.GetNumberResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetNumberResponse;
  return proto.loopup.ctgateway.v2.GetNumberResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetNumberResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetNumberResponse}
 */
proto.loopup.ctgateway.v2.GetNumberResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v2_types_number_pb.CTNumber;
      reader.readMessage(value,v2_types_number_pb.CTNumber.deserializeBinaryFromReader);
      msg.setNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetNumberResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetNumberResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetNumberResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetNumberResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNumber();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      v2_types_number_pb.CTNumber.serializeBinaryToWriter
    );
  }
};


/**
 * optional CTNumber number = 1;
 * @return {?proto.loopup.ctgateway.v2.CTNumber}
 */
proto.loopup.ctgateway.v2.GetNumberResponse.prototype.getNumber = function() {
  return /** @type{?proto.loopup.ctgateway.v2.CTNumber} */ (
    jspb.Message.getWrapperField(this, v2_types_number_pb.CTNumber, 1));
};


/**
 * @param {?proto.loopup.ctgateway.v2.CTNumber|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetNumberResponse} returns this
*/
proto.loopup.ctgateway.v2.GetNumberResponse.prototype.setNumber = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetNumberResponse} returns this
 */
proto.loopup.ctgateway.v2.GetNumberResponse.prototype.clearNumber = function() {
  return this.setNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetNumberResponse.prototype.hasNumber = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetNumbersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetNumbersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    customerId: (f = msg.getCustomerId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    rangeStart: (f = msg.getRangeStart()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    rangeEnd: (f = msg.getRangeEnd()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    countryCode: (f = msg.getCountryCode()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    pageSize: (f = msg.getPageSize()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    pageNumber: (f = msg.getPageNumber()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    sortBy: jspb.Message.getFieldWithDefault(msg, 7, 0),
    sortDirection: jspb.Message.getFieldWithDefault(msg, 8, 0),
    numberListList: jspb.Message.toObjectList(msg.getNumberListList(),
    google_protobuf_wrappers_pb.StringValue.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetNumbersRequest}
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetNumbersRequest;
  return proto.loopup.ctgateway.v2.GetNumbersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetNumbersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetNumbersRequest}
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomerId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setRangeStart(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setRangeEnd(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCountryCode(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setPageSize(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setPageNumber(value);
      break;
    case 7:
      var value = /** @type {!proto.loopup.ctgateway.v2.CTNumberSortProperty} */ (reader.readEnum());
      msg.setSortBy(value);
      break;
    case 8:
      var value = /** @type {!proto.loopup.ctgateway.v2.CTNumberSortDirection} */ (reader.readEnum());
      msg.setSortDirection(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.addNumberList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetNumbersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetNumbersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomerId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getRangeStart();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getRangeEnd();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCountryCode();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPageSize();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getPageNumber();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getSortBy();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getSortDirection();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getNumberListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue customer_id = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.getCustomerId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetNumbersRequest} returns this
*/
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.setCustomerId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetNumbersRequest} returns this
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.clearCustomerId = function() {
  return this.setCustomerId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.hasCustomerId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue range_start = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.getRangeStart = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetNumbersRequest} returns this
*/
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.setRangeStart = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetNumbersRequest} returns this
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.clearRangeStart = function() {
  return this.setRangeStart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.hasRangeStart = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue range_end = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.getRangeEnd = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetNumbersRequest} returns this
*/
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.setRangeEnd = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetNumbersRequest} returns this
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.clearRangeEnd = function() {
  return this.setRangeEnd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.hasRangeEnd = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue country_code = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.getCountryCode = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetNumbersRequest} returns this
*/
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.setCountryCode = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetNumbersRequest} returns this
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.clearCountryCode = function() {
  return this.setCountryCode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.hasCountryCode = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Int32Value page_size = 5;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.getPageSize = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 5));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetNumbersRequest} returns this
*/
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetNumbersRequest} returns this
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.clearPageSize = function() {
  return this.setPageSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.hasPageSize = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Int32Value page_number = 6;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.getPageNumber = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 6));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetNumbersRequest} returns this
*/
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetNumbersRequest} returns this
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.clearPageNumber = function() {
  return this.setPageNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.hasPageNumber = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional CTNumberSortProperty sort_by = 7;
 * @return {!proto.loopup.ctgateway.v2.CTNumberSortProperty}
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.getSortBy = function() {
  return /** @type {!proto.loopup.ctgateway.v2.CTNumberSortProperty} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.CTNumberSortProperty} value
 * @return {!proto.loopup.ctgateway.v2.GetNumbersRequest} returns this
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.setSortBy = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional CTNumberSortDirection sort_direction = 8;
 * @return {!proto.loopup.ctgateway.v2.CTNumberSortDirection}
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.getSortDirection = function() {
  return /** @type {!proto.loopup.ctgateway.v2.CTNumberSortDirection} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.CTNumberSortDirection} value
 * @return {!proto.loopup.ctgateway.v2.GetNumbersRequest} returns this
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.setSortDirection = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * repeated google.protobuf.StringValue number_list = 9;
 * @return {!Array<!proto.google.protobuf.StringValue>}
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.getNumberListList = function() {
  return /** @type{!Array<!proto.google.protobuf.StringValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {!Array<!proto.google.protobuf.StringValue>} value
 * @return {!proto.loopup.ctgateway.v2.GetNumbersRequest} returns this
*/
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.setNumberListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.google.protobuf.StringValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.addNumberList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.google.protobuf.StringValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.GetNumbersRequest} returns this
 */
proto.loopup.ctgateway.v2.GetNumbersRequest.prototype.clearNumberListList = function() {
  return this.setNumberListList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v2.GetNumbersResponse.repeatedFields_ = [1,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetNumbersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetNumbersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetNumbersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetNumbersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    v2_types_number_pb.CTNumber.toObject, includeInstance),
    paginationInfo: (f = msg.getPaginationInfo()) && v2_types_pagination_pb.PaginationInfo.toObject(includeInstance, f),
    inProgressList: jspb.Message.toObjectList(msg.getInProgressList(),
    v2_types_number_pb.NumberPendingChanges.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetNumbersResponse}
 */
proto.loopup.ctgateway.v2.GetNumbersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetNumbersResponse;
  return proto.loopup.ctgateway.v2.GetNumbersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetNumbersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetNumbersResponse}
 */
proto.loopup.ctgateway.v2.GetNumbersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v2_types_number_pb.CTNumber;
      reader.readMessage(value,v2_types_number_pb.CTNumber.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = new v2_types_pagination_pb.PaginationInfo;
      reader.readMessage(value,v2_types_pagination_pb.PaginationInfo.deserializeBinaryFromReader);
      msg.setPaginationInfo(value);
      break;
    case 3:
      var value = new v2_types_number_pb.NumberPendingChanges;
      reader.readMessage(value,v2_types_number_pb.NumberPendingChanges.deserializeBinaryFromReader);
      msg.addInProgress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetNumbersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetNumbersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetNumbersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetNumbersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      v2_types_number_pb.CTNumber.serializeBinaryToWriter
    );
  }
  f = message.getPaginationInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      v2_types_pagination_pb.PaginationInfo.serializeBinaryToWriter
    );
  }
  f = message.getInProgressList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      v2_types_number_pb.NumberPendingChanges.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CTNumber items = 1;
 * @return {!Array<!proto.loopup.ctgateway.v2.CTNumber>}
 */
proto.loopup.ctgateway.v2.GetNumbersResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v2.CTNumber>} */ (
    jspb.Message.getRepeatedWrapperField(this, v2_types_number_pb.CTNumber, 1));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v2.CTNumber>} value
 * @return {!proto.loopup.ctgateway.v2.GetNumbersResponse} returns this
*/
proto.loopup.ctgateway.v2.GetNumbersResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loopup.ctgateway.v2.CTNumber=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v2.CTNumber}
 */
proto.loopup.ctgateway.v2.GetNumbersResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loopup.ctgateway.v2.CTNumber, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.GetNumbersResponse} returns this
 */
proto.loopup.ctgateway.v2.GetNumbersResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional PaginationInfo pagination_info = 2;
 * @return {?proto.loopup.ctgateway.v2.PaginationInfo}
 */
proto.loopup.ctgateway.v2.GetNumbersResponse.prototype.getPaginationInfo = function() {
  return /** @type{?proto.loopup.ctgateway.v2.PaginationInfo} */ (
    jspb.Message.getWrapperField(this, v2_types_pagination_pb.PaginationInfo, 2));
};


/**
 * @param {?proto.loopup.ctgateway.v2.PaginationInfo|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetNumbersResponse} returns this
*/
proto.loopup.ctgateway.v2.GetNumbersResponse.prototype.setPaginationInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetNumbersResponse} returns this
 */
proto.loopup.ctgateway.v2.GetNumbersResponse.prototype.clearPaginationInfo = function() {
  return this.setPaginationInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetNumbersResponse.prototype.hasPaginationInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated NumberPendingChanges in_progress = 3;
 * @return {!Array<!proto.loopup.ctgateway.v2.NumberPendingChanges>}
 */
proto.loopup.ctgateway.v2.GetNumbersResponse.prototype.getInProgressList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v2.NumberPendingChanges>} */ (
    jspb.Message.getRepeatedWrapperField(this, v2_types_number_pb.NumberPendingChanges, 3));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v2.NumberPendingChanges>} value
 * @return {!proto.loopup.ctgateway.v2.GetNumbersResponse} returns this
*/
proto.loopup.ctgateway.v2.GetNumbersResponse.prototype.setInProgressList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.loopup.ctgateway.v2.NumberPendingChanges=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges}
 */
proto.loopup.ctgateway.v2.GetNumbersResponse.prototype.addInProgress = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.loopup.ctgateway.v2.NumberPendingChanges, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.GetNumbersResponse} returns this
 */
proto.loopup.ctgateway.v2.GetNumbersResponse.prototype.clearInProgressList = function() {
  return this.setInProgressList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.CreateNumberRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.CreateNumberRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    ddi: jspb.Message.getFieldWithDefault(msg, 1, ""),
    numberStatus: jspb.Message.getFieldWithDefault(msg, 2, 0),
    customerId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    siteId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    allocationStatus: jspb.Message.getFieldWithDefault(msg, 5, 0),
    countryCode: jspb.Message.getFieldWithDefault(msg, 6, ""),
    geographyType: jspb.Message.getFieldWithDefault(msg, 7, 0),
    supplier: jspb.Message.getFieldWithDefault(msg, 8, 0),
    hostType: jspb.Message.getFieldWithDefault(msg, 9, 0),
    usageType: jspb.Message.getFieldWithDefault(msg, 10, 0),
    mainBillingNumber: jspb.Message.getFieldWithDefault(msg, 11, ""),
    numberOwnedByLoopup: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    numberRange: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.CreateNumberRequest}
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.CreateNumberRequest;
  return proto.loopup.ctgateway.v2.CreateNumberRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.CreateNumberRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.CreateNumberRequest}
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDdi(value);
      break;
    case 2:
      var value = /** @type {!proto.loopup.ctgateway.v2.NumberStatus} */ (reader.readEnum());
      msg.setNumberStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 5:
      var value = /** @type {!proto.loopup.ctgateway.v2.CTAllocationStatus} */ (reader.readEnum());
      msg.setAllocationStatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryCode(value);
      break;
    case 7:
      var value = /** @type {!proto.loopup.ctgateway.v2.CTNumberType} */ (reader.readEnum());
      msg.setGeographyType(value);
      break;
    case 8:
      var value = /** @type {!proto.loopup.ctgateway.v2.Supplier} */ (reader.readEnum());
      msg.setSupplier(value);
      break;
    case 9:
      var value = /** @type {!proto.loopup.ctgateway.v2.HostType} */ (reader.readEnum());
      msg.setHostType(value);
      break;
    case 10:
      var value = /** @type {!proto.loopup.ctgateway.v2.UsageType} */ (reader.readEnum());
      msg.setUsageType(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setMainBillingNumber(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNumberOwnedByLoopup(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setNumberRange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.CreateNumberRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.CreateNumberRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDdi();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNumberStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getCustomerId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAllocationStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getCountryCode();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getGeographyType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getSupplier();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getHostType();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getUsageType();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getMainBillingNumber();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getNumberOwnedByLoopup();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getNumberRange();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional string ddi = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.getDdi = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.CreateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.setDdi = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional NumberStatus number_status = 2;
 * @return {!proto.loopup.ctgateway.v2.NumberStatus}
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.getNumberStatus = function() {
  return /** @type {!proto.loopup.ctgateway.v2.NumberStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.NumberStatus} value
 * @return {!proto.loopup.ctgateway.v2.CreateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.setNumberStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string customer_id = 3;
 * @return {string}
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.getCustomerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.CreateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.setCustomerId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string site_id = 4;
 * @return {string}
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.CreateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional CTAllocationStatus allocation_status = 5;
 * @return {!proto.loopup.ctgateway.v2.CTAllocationStatus}
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.getAllocationStatus = function() {
  return /** @type {!proto.loopup.ctgateway.v2.CTAllocationStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.CTAllocationStatus} value
 * @return {!proto.loopup.ctgateway.v2.CreateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.setAllocationStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string country_code = 6;
 * @return {string}
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.getCountryCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.CreateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.setCountryCode = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional CTNumberType geography_type = 7;
 * @return {!proto.loopup.ctgateway.v2.CTNumberType}
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.getGeographyType = function() {
  return /** @type {!proto.loopup.ctgateway.v2.CTNumberType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.CTNumberType} value
 * @return {!proto.loopup.ctgateway.v2.CreateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.setGeographyType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional Supplier supplier = 8;
 * @return {!proto.loopup.ctgateway.v2.Supplier}
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.getSupplier = function() {
  return /** @type {!proto.loopup.ctgateway.v2.Supplier} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.Supplier} value
 * @return {!proto.loopup.ctgateway.v2.CreateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.setSupplier = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional HostType host_type = 9;
 * @return {!proto.loopup.ctgateway.v2.HostType}
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.getHostType = function() {
  return /** @type {!proto.loopup.ctgateway.v2.HostType} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.HostType} value
 * @return {!proto.loopup.ctgateway.v2.CreateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.setHostType = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional UsageType usage_type = 10;
 * @return {!proto.loopup.ctgateway.v2.UsageType}
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.getUsageType = function() {
  return /** @type {!proto.loopup.ctgateway.v2.UsageType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.UsageType} value
 * @return {!proto.loopup.ctgateway.v2.CreateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.setUsageType = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional string main_billing_number = 11;
 * @return {string}
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.getMainBillingNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.CreateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.setMainBillingNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional bool number_owned_by_loopup = 12;
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.getNumberOwnedByLoopup = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.loopup.ctgateway.v2.CreateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.setNumberOwnedByLoopup = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional string number_range = 13;
 * @return {string}
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.getNumberRange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.CreateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.CreateNumberRequest.prototype.setNumberRange = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.CreateNumberResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.CreateNumberResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.CreateNumberResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.CreateNumberResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.CreateNumberResponse}
 */
proto.loopup.ctgateway.v2.CreateNumberResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.CreateNumberResponse;
  return proto.loopup.ctgateway.v2.CreateNumberResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.CreateNumberResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.CreateNumberResponse}
 */
proto.loopup.ctgateway.v2.CreateNumberResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.CreateNumberResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.CreateNumberResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.CreateNumberResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.CreateNumberResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.UpdateNumberRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.UpdateNumberRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    ddi: jspb.Message.getFieldWithDefault(msg, 1, ""),
    numberStatusId: (f = msg.getNumberStatusId()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    groupId: (f = msg.getGroupId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    supplierId: (f = msg.getSupplierId()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    userAllocationStatusId: (f = msg.getUserAllocationStatusId()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    userTypeId: (f = msg.getUserTypeId()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    hostType: (f = msg.getHostType()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    geographyTypeId: (f = msg.getGeographyTypeId()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    oculeusSyncStatusId: (f = msg.getOculeusSyncStatusId()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    ribbonSyncStatusId: (f = msg.getRibbonSyncStatusId()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    usageTypeId: (f = msg.getUsageTypeId()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    leadNumber: (f = msg.getLeadNumber()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    numberRange: (f = msg.getNumberRange()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    userName: (f = msg.getUserName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    upn: (f = msg.getUpn()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    drNumber: (f = msg.getDrNumber()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    numberOwnedByLoopup: (f = msg.getNumberOwnedByLoopup()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    serviceUserId: (f = msg.getServiceUserId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    customerId: (f = msg.getCustomerId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    callerId: (f = msg.getCallerId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    sipAddress: (f = msg.getSipAddress()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.UpdateNumberRequest;
  return proto.loopup.ctgateway.v2.UpdateNumberRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.UpdateNumberRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDdi(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setNumberStatusId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setGroupId(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setSupplierId(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setUserAllocationStatusId(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setUserTypeId(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setHostType(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setGeographyTypeId(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setOculeusSyncStatusId(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setRibbonSyncStatusId(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setUsageTypeId(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setLeadNumber(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setNumberRange(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setUserName(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setUpn(value);
      break;
    case 16:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDrNumber(value);
      break;
    case 17:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setNumberOwnedByLoopup(value);
      break;
    case 18:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setServiceUserId(value);
      break;
    case 19:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomerId(value);
      break;
    case 20:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCallerId(value);
      break;
    case 21:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSipAddress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.UpdateNumberRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.UpdateNumberRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDdi();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNumberStatusId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getGroupId();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSupplierId();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getUserAllocationStatusId();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getUserTypeId();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getHostType();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getGeographyTypeId();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getOculeusSyncStatusId();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getRibbonSyncStatusId();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getUsageTypeId();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getLeadNumber();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getNumberRange();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getUserName();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getUpn();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDrNumber();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getNumberOwnedByLoopup();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getServiceUserId();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCustomerId();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCallerId();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSipAddress();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string ddi = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.getDdi = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.setDdi = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Int32Value number_status_id = 2;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.getNumberStatusId = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 2));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.setNumberStatusId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.clearNumberStatusId = function() {
  return this.setNumberStatusId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.hasNumberStatusId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue group_id = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.getGroupId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.setGroupId = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.clearGroupId = function() {
  return this.setGroupId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.hasGroupId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Int32Value supplier_id = 4;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.getSupplierId = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 4));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.setSupplierId = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.clearSupplierId = function() {
  return this.setSupplierId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.hasSupplierId = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Int32Value user_allocation_status_id = 5;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.getUserAllocationStatusId = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 5));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.setUserAllocationStatusId = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.clearUserAllocationStatusId = function() {
  return this.setUserAllocationStatusId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.hasUserAllocationStatusId = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Int32Value user_type_id = 6;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.getUserTypeId = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 6));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.setUserTypeId = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.clearUserTypeId = function() {
  return this.setUserTypeId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.hasUserTypeId = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Int32Value host_type = 7;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.getHostType = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 7));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.setHostType = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.clearHostType = function() {
  return this.setHostType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.hasHostType = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Int32Value geography_type_id = 8;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.getGeographyTypeId = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 8));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.setGeographyTypeId = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.clearGeographyTypeId = function() {
  return this.setGeographyTypeId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.hasGeographyTypeId = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Int32Value oculeus_sync_status_id = 9;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.getOculeusSyncStatusId = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 9));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.setOculeusSyncStatusId = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.clearOculeusSyncStatusId = function() {
  return this.setOculeusSyncStatusId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.hasOculeusSyncStatusId = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Int32Value ribbon_sync_status_id = 10;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.getRibbonSyncStatusId = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 10));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.setRibbonSyncStatusId = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.clearRibbonSyncStatusId = function() {
  return this.setRibbonSyncStatusId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.hasRibbonSyncStatusId = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Int32Value usage_type_id = 11;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.getUsageTypeId = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 11));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.setUsageTypeId = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.clearUsageTypeId = function() {
  return this.setUsageTypeId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.hasUsageTypeId = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.StringValue lead_number = 12;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.getLeadNumber = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 12));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.setLeadNumber = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.clearLeadNumber = function() {
  return this.setLeadNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.hasLeadNumber = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.StringValue number_range = 13;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.getNumberRange = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 13));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.setNumberRange = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.clearNumberRange = function() {
  return this.setNumberRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.hasNumberRange = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.StringValue user_name = 14;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.getUserName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 14));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.setUserName = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.clearUserName = function() {
  return this.setUserName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.hasUserName = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.StringValue upn = 15;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.getUpn = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 15));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.setUpn = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.clearUpn = function() {
  return this.setUpn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.hasUpn = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.protobuf.StringValue dr_number = 16;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.getDrNumber = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 16));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.setDrNumber = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.clearDrNumber = function() {
  return this.setDrNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.hasDrNumber = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional google.protobuf.BoolValue number_owned_by_loopup = 17;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.getNumberOwnedByLoopup = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 17));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.setNumberOwnedByLoopup = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.clearNumberOwnedByLoopup = function() {
  return this.setNumberOwnedByLoopup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.hasNumberOwnedByLoopup = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional google.protobuf.StringValue service_user_id = 18;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.getServiceUserId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 18));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.setServiceUserId = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.clearServiceUserId = function() {
  return this.setServiceUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.hasServiceUserId = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional google.protobuf.StringValue customer_id = 19;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.getCustomerId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 19));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.setCustomerId = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.clearCustomerId = function() {
  return this.setCustomerId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.hasCustomerId = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional google.protobuf.StringValue caller_id = 20;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.getCallerId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 20));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.setCallerId = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.clearCallerId = function() {
  return this.setCallerId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.hasCallerId = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional google.protobuf.StringValue sip_address = 21;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.getSipAddress = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 21));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.setSipAddress = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.clearSipAddress = function() {
  return this.setSipAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateNumberRequest.prototype.hasSipAddress = function() {
  return jspb.Message.getField(this, 21) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.UpdateNumberResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.UpdateNumberResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.UpdateNumberResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.UpdateNumberResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberResponse}
 */
proto.loopup.ctgateway.v2.UpdateNumberResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.UpdateNumberResponse;
  return proto.loopup.ctgateway.v2.UpdateNumberResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.UpdateNumberResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.UpdateNumberResponse}
 */
proto.loopup.ctgateway.v2.UpdateNumberResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.UpdateNumberResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.UpdateNumberResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.UpdateNumberResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.UpdateNumberResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.loopup.ctgateway.v2);
